export default {
  reviewCompleteHeader: '\u0130ncele ve Tamamla',
  participants: 'Kat\u0131l\u0131mc\u0131lar',
  enterParticipantInfoText:
    '\u00d6demeye ge\u00e7mek i\u00e7in l\u00fctfen gerekli bilgileri girin.',
  purchaser: 'Sat\u0131n Alan',
  firstName: 'Ad',
  lastName: 'Soyad',
  email: 'E-posta',
  optionalEmail: 'E-posta: (iste\u011fe ba\u011fl\u0131)',
  'phone:': 'Telefon',
  participantFieldPlaceholder:
    'Yeni ekle veya mevcut kat\u0131l\u0131mc\u0131 se\u00e7',
  reservationSummary: 'Rezervasyon \u00d6zeti',
  editParticipantsDetails: 'Kat\u0131l\u0131mc\u0131 Bilgilerini D\u00fczenle',
  participantDetails: 'Ayr\u0131nt\u0131lar',
  duplicatePurchaserText: 'Sat\u0131n Alan ile Ayn\u0131',
  phone: 'Telefon',
  addParticipant: 'Ek {{tierLabel}}',
  participant: 'Kat\u0131l\u0131mc\u0131',
  removeParticipant: 'Kald\u0131r',
  experienceCheckoutCompleted: 'Deneyim \u00d6demesi Tamamland\u0131',
  experienceCartCheckout: 'Deneyim Sepeti \u00d6demesi',
  experienceLimitReached:
    '\u00dczg\u00fcn\u00fcz, bu deneyim maksimum kat\u0131l\u0131mc\u0131 say\u0131s\u0131na ula\u015ft\u0131',
  payment: '\u00d6deme',
  duration: 'S\u00fcre',
  discountCode: '\u0130ndirim Kodu',
  removeCode: 'Kodu Kald\u0131r',
  invalidCodeValidation: 'Ge\u00e7ersiz Kupon Kodu',
  networkErrorDiscountCode: 'Bizim taraf\u0131m\u0131zda bir sorun olu\u015ftu',
  onlyOneCouponCodeAllowed: 'Yaln\u0131zca bir kupon koduna izin verilir',
  creditCodeHasAlreadyBeenApplied: 'Kredi kodu zaten uygulanm\u0131\u015f',
  discount: '\u0130ndirim',
  promo: 'Promosyon',
  promoCode: 'Promosyon kodu',
  apply: 'Uygula',
  total: 'Toplam',
  subTotal: 'Ara Toplam',
  includes: '\u0130\u00e7erir',
  and: 've',
  addHostNotes: 'Ev sahibiniz i\u00e7in not ekleyin',
  brandAggreementText:
    'Kabul ediyorum veya kat\u0131l\u0131mc\u0131(lar) ad\u0131na \u015fartlar ve ko\u015fullar\u0131 kabul etmeye yetkili oldu\u011fumu beyan ediyorum',
  termsAggreementValidation: 'L\u00fctfen \u015fartlar\u0131 kabul edin',
  firstNameValidation: 'Ad gereklidir',
  lastNameValidation: 'Soyad gereklidir',
  emailValidation: {
    emailRequiredText: 'E-posta gereklidir',
    invalidEmail: 'Ge\u00e7ersiz E-posta Adresi',
    not_specified: 'Hatal\u0131 E-posta Adresi',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Ge\u00e7ersiz Telefon Numaras\u0131',
    not_specified: 'Ge\u00e7ersiz',
    phoneRequiredText: 'Telefon numaras\u0131 gereklidir',
  },
  participantFirstNameValidation:
    'Kat\u0131l\u0131mc\u0131 Ad\u0131 gereklidir',
  participantLastNameValidation:
    'Kat\u0131l\u0131mc\u0131 Soyad\u0131 gereklidir',
  complete: 'Tamamla',
  '404Message': 'Bulunamad\u0131',
  waiting: 'Bekleniyor...',
  complimentary: '\u00dccretsiz',
  confirmationHeader: 'Deneyiminiz rezerve edildi!',
  confirmationText:
    '{{email}} adresine ek ayr\u0131nt\u0131larla birlikte bir onay e-postas\u0131 g\u00f6nderildi',
  viewAll: 'T\u00fcm Deneyimleri G\u00f6r\u00fcnt\u00fcle',
  paymentMethod: '\u00d6deme Y\u00f6ntemi',
  creditCard: 'Kredi Kart\u0131',
  roomCharge: 'Oda \u00dccreti',
  memberCharge: '\u00dcye \u00dccreti',
  roomOrReservationNumber: 'Oda Numaras\u0131 veya Onay Numaras\u0131',
  roomNumber: 'Oda Numaras\u0131',
  roomNumberLegacy: 'Oda Numaras\u0131 / Onay Kodu',
  memberNumber: '\u00dcye Numaras\u0131',
  kicc: 'KICC',
  chargeValidation: 'Oda Numaras\u0131 ve Soyad gereklidir',
  memberNumberValidation: '\u00dcye Numaras\u0131 gereklidir',
  invalidRoomNumber: 'Oda numaras\u0131 ge\u00e7ersiz',
  invalidRoomNumberLegacy: 'Oda numaras\u0131 veya onay kodu ge\u00e7ersiz',
  invalidMemberNumber: '\u00dcye numaras\u0131 ge\u00e7ersiz',
  invalidPhoneNumber: 'Telefon numaras\u0131 ge\u00e7ersiz',
  requiredPhoneNumber: 'Telefon numaras\u0131 gereklidir',
  guestNameIsRequired: 'Misafir ad\u0131 gereklidir',
  roomNumberIsRequired: 'Oda Numaras\u0131 gereklidir',
  roomNumberIsRequiredLegacy: 'Oda Numaras\u0131 veya Onay Kodu gereklidir',
  roomOrReservationNumberIsRequired:
    'Oda numaras\u0131 veya onay numaras\u0131 gereklidir',
  cardNumberIncomplete: 'Kart Numaras\u0131 Eksik',
  lastNameValidationError: 'Soyad gereklidir',
  isReqd: 'gereklidir',
  reservationCode: 'Rezervasyon/Onay Numaras\u0131',
  nonHotelGuest: 'Otel Misafiri De\u011fil',
  onPropertyGuest: 'Tesiste Konaklayan Misafir',
  preArrivalGuest: 'Var\u0131\u015f \u00d6ncesi Misafir',
  cardNumber: 'Kart numaras\u0131',
  pmsValidationErrorMessage:
    'Ge\u00e7ersiz soyad veya oda numaras\u0131 veya onay numaras\u0131',
  pmsDateValidationErrorMessage:
    '\u00dczg\u00fcn\u00fcz! Deneyim tarihi, geli\u015f ve ayr\u0131l\u0131\u015f tarihiniz aras\u0131nda de\u011fil.',
  fullName: 'Ad Soyad',
  checkout: '\u00d6deme',
  editParticipants: 'Kat\u0131l\u0131mc\u0131lar\u0131 D\u00fczenle',
  private: '\u00d6zel',
  browseAllExperieces: 'T\u00fcm deneyimlere g\u00f6z at',
  payWithCreditCard: 'Kredi Kart\u0131 ile \u00d6de',
  payWithRoomCharge: 'Oda \u00dccreti ile \u00d6de',
  payWithMemberCharge: '\u00dcye \u00dccreti ile \u00d6de',
  payWith: 'ile \u00d6de',
  bookBulkErrorByCard:
    'Rezervasyonunuzu onaylarken bir sorun olu\u015ftu. Kart\u0131n\u0131zdan \u00fccret al\u0131nmad\u0131.',
  bookBulkErrorByRoomCharge: 'Ge\u00e7ersiz soyad ve oda numaras\u0131.',
  bookBulkErrorByMemberCharge: 'Ge\u00e7ersiz soyad ve \u00fcye numaras\u0131.',
  reviewCancellation: '\u0130ptali \u0130ncele',
  selectAReservationToCancel:
    '\u0130ptal etmek i\u00e7in bir rezervasyon se\u00e7in',
  confirmCancellation: '\u0130ptali onayla',
  cancellable: '\u0130ptal edilebilir',
  cancelled: '\u0130ptal edildi',
  deadlinePassed: 'S\u00fcre doldu',
  noCancellations: '\u0130ptal yok',
  reviewReschedule: 'Rezervasyonunuz',
  selectAReservationToReschedule:
    'Yeniden planlamak i\u00e7in bir rezervasyon se\u00e7in',
  confirmReservation: 'Rezervasyonu onayla',
  confirm: 'Onayla',
  selectADateAndTime: 'Tarih ve saat se\u00e7in',
  noOtherSessionsAvailableForThisExperience:
    'Bu deneyim i\u00e7in ba\u015fka seans mevcut de\u011fil.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Bu rezervasyon art\u0131k yeniden planlanam\u0131yor. L\u00fctfen {{brandEmail}} adresine e-posta g\u00f6nderin',
  thisReservationCannotBeRescheduled: 'Bu rezervasyon yeniden planlanamaz',
  noTimesAvailable: 'Uygun saat yok',
  noBookingsAvailable: 'Uygun rezervasyon yok',
  youPaid: '\u00d6dedi\u011finiz tutar',
  refund: '\u0130ade',
  yourRefund: '\u0130adeniz',
  yourRefundWillBeProcessedToTheOriginalPayment:
    '\u0130adeniz orijinal \u00f6deme y\u00f6ntemine i\u015flenecektir.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Bu rezervasyon art\u0131k iptal edilemiyor. L\u00fctfen {{brandEmail}} adresine e-posta g\u00f6nderin',
  reservationCancelled: 'Rezervasyon iptal edildi',
  thisReservationCannotBeCancelled: 'Bu rezervasyon iptal edilemez',
  thisReservationHasAlreadyBeenCancelled:
    'Bu rezervasyon zaten iptal edilmi\u015f',
  theHotel: 'Otel',
  cancelling: '\u0130ptal ediliyor',
  somethingWentWrong: 'Bir \u015feyler ters gitti',
  previouslyRefunded: 'Daha \u00f6nce iade edildi',
  remainingBalance: 'Kalan Bakiye',
  notEnoughPoints: 'Yeterli puan yok',
  notEnoughPointsDescription:
    'Bu sat\u0131n alma i\u015flemini tamamlamak i\u00e7in yeterli World of Hyatt Puan\u0131n\u0131z yok.',
  currentPointsBalance: 'Mevcut puan bakiyesi: {{count, number}}',
  points: 'puan',
  pointsWithCount_one: '{{count, number}} puan',
  pointsWithCount_other: '{{count, number}} puan',
  payWithHyattPoints: 'Hyatt Puanlar\u0131 ile \u00d6de',
  pleaseSignIn: 'L\u00fctfen Giri\u015f Yap\u0131n',
  worldOfHyattPoints: 'World of Hyatt Puanlar\u0131',
  bookBulkErrorByNotEnoughSeats:
    'Seans i\u00e7in yeterli koltuk yok. L\u00fctfen ba\u015fka bir seans deneyin.',
  phoneNumber: 'Telefon numaras\u0131',
  requestToBookConfirmationText:
    '{{email}} adresine bir onay e-postas\u0131 g\u00f6nderildi',
  reservationRescheduled: 'Rezervasyon yeniden planland\u0131',
  yourReservationWasRescheduledTo:
    'Rezervasyonunuz \u015fu tarihe yeniden planland\u0131',
  viewExperiences: 'Deneyimleri g\u00f6r\u00fcnt\u00fcle',
  joinBook: 'Kat\u0131l ve Rezerve Et',
  signInBook: 'Giri\u015f Yap ve Rezerve Et',
  signAndJoin:
    'Rezerve Etmek i\u00e7in Giri\u015f Yap\u0131n veya Kat\u0131l\u0131n',
  signAndJoinDescription:
    'World of Hyatt FIND Deneyimleri World of Hyatt \u00fcyelerine \u00f6zeldir. Giri\u015f yap\u0131n veya kat\u0131l\u0131n, rezerve edin ve puan kazan\u0131n. Kat\u0131lmak istemiyor musunuz? Sepetinizden World of Hyatt Deneyimini kald\u0131rarak \u00f6zel olmayan deneyimleri yine de rezerve edebilirsiniz.',
  promoOrFind: 'Promosyon veya Find Kredi Kodu',
  hyattTermsAndConditions: '\u015eartlar ve Ko\u015fullar',
  hyattTermsAndConditionsAgreement:
    'Bu rezervasyonu onaylayarak iptal politikas\u0131n\u0131 kabul ediyorum. Ayr\u0131ca ki\u015fisel bilgilerimin kullan\u0131m\u0131n\u0131 a\u015fa\u011f\u0131dakiler do\u011frultusunda okudum ve kabul ediyorum',
  hyattTermsAndConditionsLink: 'Hyatt Gizlilik Politikalar\u0131',
  hyattWaiverText:
    'Bu deneyimi sat\u0131n alarak, hem kendi ad\u0131ma hem de taraf\u0131mdan sat\u0131n al\u0131nan deneyime kat\u0131lan herhangi bir ki\u015fi ad\u0131na (varsa) a\u015fa\u011f\u0131dakileri kabul ediyorum, anl\u0131yorum ve onaylayorum',
  hyattWaiverLink: 'genel feragat',
  priceDisclaimer: 'Vergiler \u00f6ncesi \u00fccretleri i\u00e7erir',
  curatedRecommendations: 'Se\u00e7ilmi\u015f \u00f6neriler',
  moreExperiencesYouMightLike:
    'Be\u011fenebilece\u011finiz di\u011fer deneyimler',
  similarExperiencesAvailableToBookDirectly:
    'Doğrudan rezerve edebileceğiniz benzer deneyimler',
  experiencesAvailableAroundYourBookingDate:
    'Rezervasyon tarihiniz civar\u0131nda mevcut deneyimler',
  confirmationEmailSent:
    'Onay\u0131n\u0131z\u0131 daha fazla ayr\u0131nt\u0131yla birlikte {{email}} adresine g\u00f6nderdik.',
  youreBooked: 'Rezervasyonunuz yap\u0131ld\u0131',
  purchaserInformation: 'Sat\u0131n Alan Bilgileri',
  requiredFieldIndicator: '* zorunlu alan\u0131 belirtir',
  resourceSelectionTitle: 'Seçeneklerinizi belirleyin',
  resourceSelectionDescription:
    'Rezervasyonunuzdaki her öğe için bir seçenek belirleyin.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: '{{attributeName}} seçin',
  resourceValueSoldOut: '{{label}} (tükendi)',
  resourceValueUnavailableWith: '{{label}} ({{picks}} ile mevcut değil)',
  resourceOptionsUnavailable:
    'Bu saat için seçenekler yüklenemedi. Lütfen tekrar deneyin.',
  resourceOptionsRetry: 'Tekrar dene',
  changeResourceSelections: 'Seçimlerinizi değiştirin',
};
